var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.201,
    height: 25.676,
    viewBox: "0 0 23.201 25.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#582bb8;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.834,21.148a3.753,3.753,0,0,0-2.526.992l-9.19-5.349a4.219,4.219,0,0,0,.116-.9,4.219,4.219,0,0,0-.116-.9L21.2,9.69a3.858,3.858,0,1,0-1.237-2.823,4.219,4.219,0,0,0,.116.9L11,13.067a3.867,3.867,0,1,0,0,5.646l9.177,5.362a3.636,3.636,0,0,0-.1.838,3.764,3.764,0,1,0,3.764-3.764Z",
    transform: "translate(-4.5 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/Icon-share.a0b6c29bf49b2dcf0f334dee5e7e15a5.svg";
export { ForwardRef as ReactComponent };